// extracted by mini-css-extract-plugin
export var changeIcon = "_5b-4";
export var clickable = "_5b-8";
export var container = "_5b-0";
export var divider = "_5b-7";
export var externalLinkIcon = "_5b-1";
export var green = "_5b-5";
export var helpCircleIcon = "_5b-3";
export var iconButton = "_5b-2";
export var red = "_5b-6";